// these events are only used in ZRMW unlike the ones in modules/clickstream shared directory
export const ZRM_GTM_EVENTS = {
  RENTAL_MANAGER_PUBLISH: 'RentalManager::Publish',
  RENTAL_MANAGER_PAY_PUBLISH: 'RentalManager::PayPublish',
};
